import { Loader2, Plus, Trash2, Clapperboard } from 'lucide-react';
import { STATUS_META } from './storyboardApi';

export default function StoryboardList({ boards, loading, creating, error, onCreate, onOpen, onDelete }) {
  return (
    <div className="p-4 md:p-6 max-w-4xl space-y-5" data-testid="sb-list">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-sm font-semibold text-gray-900">Storyboard</h3>
          <p className="text-xs text-gray-400 mt-0.5">
            Full campaign production — brief, creative concept, and up to 15 consistent scenes.
          </p>
        </div>
        <button
          data-testid="sb-new-btn"
          onClick={onCreate}
          disabled={creating}
          className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-xs font-medium bg-gray-900 text-white hover:bg-gray-800 transition-all active:scale-[0.98] disabled:opacity-50"
        >
          {creating ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Plus className="w-3.5 h-3.5" />}
          New Storyboard
        </button>
      </div>

      {error && <p className="text-xs text-red-500" data-testid="sb-list-error">{error}</p>}

      {loading ? (
        <div className="flex items-center gap-2 text-sm text-gray-400 py-8">
          <Loader2 className="w-4 h-4 animate-spin" /> Loading storyboards...
        </div>
      ) : boards.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-gray-200/70 bg-white/30 p-10 text-center" data-testid="sb-empty">
          <Clapperboard className="w-8 h-8 text-gray-300 mx-auto mb-3" />
          <p className="text-sm text-gray-500 font-medium">No storyboards yet</p>
          <p className="text-xs text-gray-400 mt-1">
            Create one to plan a full visual campaign with AI direction.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {boards.map(b => {
            const meta = STATUS_META[b.status] || STATUS_META.briefing;
            return (
              <button
                key={b.id}
                data-testid={`sb-card-${b.id}`}
                onClick={() => onOpen(b.id)}
                className="group text-left rounded-2xl border border-gray-200/50 bg-white/40 hover:bg-white/70 hover:border-gray-300/60 transition-all p-4"
              >
                <div className="flex items-start justify-between gap-2">
                  <p className="text-sm font-medium text-gray-900 line-clamp-2">
                    {b.title || 'Untitled storyboard'}
                  </p>
                  <span
                    onClick={(e) => { e.stopPropagation(); onDelete(b.id); }}
                    data-testid={`sb-delete-${b.id}`}
                    className="opacity-0 group-hover:opacity-100 transition-opacity p-1 rounded-md hover:bg-red-50 text-gray-300 hover:text-red-500 cursor-pointer"
                  >
                    <Trash2 className="w-3.5 h-3.5" />
                  </span>
                </div>
                <div className="flex items-center gap-2 mt-3">
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${meta.cls}`}>
                    {meta.label}
                  </span>
                  <span className="text-[10px] text-gray-400">
                    {b.created_at ? new Date(b.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : ''}
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
